import request from "@/util/request";
export function GetLoginConfig(data) {
  return request({
    url: "/api/Auth/GetLoginConfig",
    method: "get",
    params: data
  });
}
export function Login(data) {
  return request({
    url: "/api/Auth/Login",
    method: "post",
    data
  });
}
export function axiosGetNewToken() {
  return request({
    url: "/api/Auth/GetNewToken",
    method: "get",
    params: {
      token: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).refreshToken : ''
    }
  })
}
export function Logout(data) {
  return request({
    url: "/api/Auth/Logout",
    method: "get",
    params: data
  });
}
export function Captcha(data) {
  return request({
    url: "/api/Auth/Captcha",
    method: "get",
    params: data
  });
}
export function ChangePassword(data) {
  return request({
    url: "/api/Auth/ChangePassword",
    method: "post",
    data
  });
}
export function GetPageConfig(data) {
  return request({
    url: "/api/Auth/GetPageConfig",
    method: "get",
    params: data
  });
}
export function GetAppUserList(data) {
  return request({
    url: "/api/Auth/GetAppUserList",
    method: "get",
    params: data
  });
}
export function SetAppUserAuditStatus(data) {
  return request({
    url: "/api/Auth/SetAppUserAuditStatus",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/auth.js